module.exports = __webpack_public_path__ + "static/media/magicbanner_sm1.9004801e.jpg";